<template>
  <el-container class="index-con">
    <el-aside :class="showclass">
      <LeftNav />
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <!-- <navcon></navcon> -->
        <el-breadcrumb separator=" /">
          <el-breadcrumb-item
            v-for="(i, k) in $route.matched.slice(1)"
            :key="k"
          >
            {{ i.meta.title }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>
      <el-main class="index-main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import LeftNav from "./leftnav.vue";
export default {
  name: "Layout",
  data() {
    return {
      showclass: "asideshow",
      showtype: false
    };
  },
  // 注册组件
  components: {
    LeftNav
  },
  methods: {},
  created() {
    // 监听
    this.$root.Bus.$on("toggle", value => {
      if (value) {
        this.showclass = "asideshow";
      } else {
        setTimeout(() => {
          this.showclass = "aside";
        }, 300);
      }
    });
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    // this.$message({
    //   message: '登录成功',
    //   type: 'success'
    // })
  }
};
</script>
<style scoped lang="less">
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  // background-color: #334157;
  margin: 0px;
}
.asideshow {
  width: 14.375rem !important;
  height: 100%;
  // background: linear-gradient(156deg, #004fce 0%, #226bdc 100%);
  background-color: #f5f8fd;
  margin: 0px;
  overflow-x: hidden;
}
.index-header {
  display: flex;
  align-items: center;
  height: 64px !important;
  box-shadow: 0px 1px 4px 0px #1f001529;
  .el-breadcrumb {
    padding: 0 22px;
  }
  /deep/ .el-breadcrumb__separator {
    color: #1d2129;
    font-size: 16px;
    margin: 0 2px;
  }
  /deep/ .el-breadcrumb__inner {
    color: #1d2129;
    font-size: 16px;
  }
}

/deep/ .el-header {
  padding: 0;
}
/deep/ .el-main {
  padding: 24px;
  background-color: #f5f8fd;
}
.el-main .index-main {
  /* bg */
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/index.vue